<template>
  <main id="main" class="--full page">
    <template v-if="page">
      <section class="section section__content">
        <AuthHeader :content="page.header" :no-return="['group_size', 'options'].includes(type)" />
        <component :is="form" />
        <TermsBlock centered />
      </section>
      <slot />
    </template>
  </main>
</template>

<script>
import { AuthHeader, TermsBlock } from '@/components/blocks'
import {
  AuthConfirmationForm,
  AuthGroupSizeForm,
  AuthLoginForm,
  AuthOptionsForm,
} from '@/components/form/auth'

export default {
  name: 'AuthPage',
  components: { AuthHeader, TermsBlock },
  props: {
    page: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      required: true,
      validator: (value) => ['confirmation', 'group_size', 'login', 'options'].includes(value),
    },
  },
  computed: {
    form() {
      switch (this.type) {
        case 'confirmation':
          return AuthConfirmationForm
        case 'group_size':
          return AuthGroupSizeForm
        case 'login':
          return AuthLoginForm
        case 'options':
          return AuthOptionsForm
        default:
          return null
      }
    },
  },
}
</script>
